/**
 * Created by Ning Jiang on 12/7/2016.
 */

import { ReelSpriteSymbol } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbol";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { TimelineMax, Bounce, TweenLite } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SymbolMultiplyCounter } from "../../presentations/independent/symbol/SymbolMultiplyCounter";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { ISymbolAnimationConf, ISymbolConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BLEND_MODES, Texture } from "pixi.js";
import { JumpingWildController } from "../../presentations/independent/jumpingWild/JumpingWildController";
import { SanEngineController } from "../SanEngineController";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../SanGameConfig";
import { SanEngineManager } from "../SanEngineManager";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { PayTableEvent } from "./MiniPayTable";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { SpinePlayer } from "../../proto/SpinePlayer";
import { SanSymbolData } from "./SanSymbolData";
import { MultSequence } from "../../proto/MultSequence";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { ReelOverlay } from "../../presentations/background/ReelOverlay";

export class SanSymState extends ReelSymbolStates {
    public static readonly SPLIT: string = "split";
    public static readonly SPIN_ATTENTION: string = "SPIN_ATTENTION";
}

export class SanSpriteSymbol extends ReelSpriteSymbol {

    private sizeTl: TimelineMax;

    private multies: SymbolMultiplyCounter[] | undefined;

    private attention_Spin: Sequence | null;
    private attentionSp_Spin_path: string = "FlyBy_Spin";

    private attentionSp: Sequence | null;
    private attentionSp_path: string = "Blink_Reel";

    private direction_path: string = "Dirr_Attention";
    private directionSeq: Sequence | null;

    private seq_glows: MultSequence[] | undefined;

    private seq_transform: Sequence | null;
    private seq_transform_end: Sequence | null;

    private seq_frames: Sequence[] | undefined;

    private tl_Loop: TimelineMax;
    private tl_Split: TimelineMax;

    private split_spine: SpinePlayer;

    private seq_attention_path: string = "S_W_A";
    private seq_attention: Sequence | undefined;
    private seq_attention_reverse: boolean = false;

    private win_toggle: SpinePlayer;

    private split_syms: PIXI.Sprite[];
    private fsMultBars: PIXI.Sprite[];

    private jw_mult: PIXI.Sprite;

    private get winFrameSeq(): Sequence[] {
        if (this.stateType.equal(4) && !this.Splitted)
            return [this.seq_frames![0]];
        else if (!this.Splitted && this.stateType.equal(2))
            return [this.seq_frames![0]];
        else if (this.stateType.equal(2))
            return [this.seq_frames![0], this.seq_frames![1]];
        return this.seq_frames!;
    }

    private get winFlashSprites(): MultSequence[] {
        if (this.stateType.equal(4) && !this.Splitted)
            return [this.seq_glows![0]];
        else if (!this.Splitted && this.stateType.equal(2))
            return [this.seq_glows![0]];
        else if (this.stateType.equal(2))
            return [this.seq_glows![0], this.seq_glows![1]];
        return this.seq_glows!;
    }

    public get multiplier(): SymbolMultiplyCounter | undefined {
        return this.multies ? this.multies[0] : undefined;
    }

    private get Splitted(): boolean {
        return !!this.split_syms;
    }

    constructor(ID: number, symName: string, state: string = ReelSymbolStates.NORMAL, size: number = 4) {
        super(ID, symName, state, size);
    }

    public changeSymbol(symName: string): void {
        super.changeSymbol(symName);

        if(this.split_syms){
            let t: Texture = SanSymbolData.getTextures(symName, "normal", "2")[0];
            this.split_syms.forEach(s => s.texture = t);
        }
    }

    private sendToMiniTable(): void {
        EventHandler.dispatchEvent(new GameEvent(PayTableEvent.CLICK, { dispObj: this._currentAnimation, name: this.symName }));
    }

    private Split(times: number = 2): TimelineMax {
        this.createSplitSyms();
        // times = 4;
        this.tl_Split = Helper.timeLineKiller(this.tl_Split, new TimelineMax());
        this.tl_Split.add(this.split_spine.play({ name: "Split" }));
        const splitDurr: number = this.split_spine.fetchDuration("Split") / 2;
        
        if (this.fsMultBars) {
            this.tl_Split.staggerTo([
                this.multies![0],this.multies![1],this.fsMultBars[0],this.fsMultBars[1]
            ],splitDurr,{alpha:1}, 0, splitDurr/4)

            this.tl_Split.add([
                () =>{
                    this.fsMultBars.forEach(f => f.texture = GameResources.getTextures("Sym_Frame_Multiplier_2")[0]);
                },
                TweenLite.to(this.multies![0], splitDurr, { y: Math.floor(130 / 2)}),
                TweenLite.to(this.multies![1], splitDurr, { y: Math.floor(-45 / 2)}), 

                TweenLite.to(this.fsMultBars[0], splitDurr, { y: Math.floor(this.symbolHeight / 4) + 1 }),
                TweenLite.to(this.fsMultBars[1], splitDurr, { y: Math.floor(-this.symbolHeight / 4) + 1 }),
            ], splitDurr / 4)
            // this.multies[0].position.y = (this.stateType.equal(4) ? 180 / 2 : 180 / 3) - this.multies[0].height / 2;
        }
        this.tl_Split.add([
            TweenLite.to(this.split_syms[0], splitDurr, { alpha: 1 }),
            TweenLite.to(this.split_syms[1], splitDurr, { alpha: 1 }),
            TweenLite.to(this.currentStateAnim, splitDurr, { alpha: 0 }),
            TweenLite.to(this._oldAnimation, splitDurr, { alpha: 0 }),
            TweenLite.to(this.split_syms[0], splitDurr, { y: Math.floor(this.symbolHeight / 4) + 1 }),
            TweenLite.to(this.split_syms[1], splitDurr, { y: Math.floor(-this.symbolHeight / 4) + 1 }),
        ], splitDurr / 4)

        if (times != 2) {
            this.tl_Split.add([
                () => this.split_spine.play({ name: "Split" }),
                () => {
                    let t2: Texture = SanSymbolData.getTextures(this.symName, "normal", "1")[0];
                    this.split_syms[0].texture = t2;
                    this.split_syms[1].texture = t2;
                },
            ])
            this.tl_Split.add([
                TweenLite.to(this.split_syms[2], splitDurr, { alpha: 1 }),
                TweenLite.to(this.split_syms[3], splitDurr, { alpha: 1 }),
                TweenLite.to(this.split_syms[0], splitDurr, { y: Math.floor(this.symbolHeight / 2.75) + 1 }),
                TweenLite.to(this.split_syms[1], splitDurr, { y: Math.floor(-this.symbolHeight / 2.75) + 1 }),
                TweenLite.to(this.split_syms[2], splitDurr, { y: Math.floor(this.symbolHeight / 8) + 1 }),
                TweenLite.to(this.split_syms[3], splitDurr, { y: Math.floor(-this.symbolHeight / 8) + 1 }),
                () => {
                    if (!this.fsMultBars) return;
                    this.fsMultBars.forEach(f => f.texture = GameResources.getTextures("Sym_Frame_Multiplier_1")[0]);
                    TweenLite.to(this.fsMultBars[2], splitDurr, { alpha: 1 });
                    TweenLite.to(this.fsMultBars[3], splitDurr, { alpha: 1 });
                    TweenLite.to(this.fsMultBars[0], splitDurr, { y: Math.floor(this.symbolHeight / 2.75) + 1 });
                    TweenLite.to(this.fsMultBars[1], splitDurr, { y: Math.floor(-this.symbolHeight / 2.75) + 1 });
                    TweenLite.to(this.fsMultBars[2], splitDurr, { y: Math.floor(this.symbolHeight / 8) + 1 });
                    TweenLite.to(this.fsMultBars[3], splitDurr, { y: Math.floor(-this.symbolHeight / 8) + 1 });

                    TweenLite.to(this.multies![2], splitDurr, { alpha: 1 });
                    TweenLite.to(this.multies![3], splitDurr, { alpha: 1 });
                    TweenLite.to(this.multies![0], splitDurr, { y: Math.floor(140 / 2)});
                    TweenLite.to(this.multies![1], splitDurr, { y: Math.floor(-35 / 2)}); 
                    TweenLite.to(this.multies![2], splitDurr, { y: Math.floor(55 / 2)});
                    TweenLite.to(this.multies![3], splitDurr, { y: Math.floor(-120 / 2)}); 
                }
            ],"-=" +  splitDurr / 4)
          
        }

        this.stateType.set(times == 2 ? 2 : 1);

        return this.tl_Split;
    }

    private createSplitSyms(): void {
        if (!this.split_syms) {
            this.split_syms = [];
            let t: Texture = SanSymbolData.getTextures(this.symName, "normal", "2")[0];
            let t2: Texture = SanSymbolData.getTextures(this.symName, "normal", "1")[0];

            this.split_syms.push(this.addChild(Helper.createSprite(t)));
            this.split_syms.push(this.addChild(Helper.createSprite(t)));
            this.split_syms.push(this.addChild(Helper.createSprite(t2)));
            this.split_syms.push(this.addChild(Helper.createSprite(t2)));
            this.split_syms.forEach(s => s.zIndex = 50 )

            this.split_spine = this.addChild(new SpinePlayer("Split"));
            this.split_spine.zIndex = 600;
            this._attentionGFX.zIndex = 550;
            this.sortChildren();
        }
    }

    public get isJumpWild(): boolean {
        return this.symName == "W_J";
    }

    public changeState(conf: ISymbolAnimationConf): TimelineMax | null {

        if (conf.state == SanSymState.SPLIT) {
            return this.Split();
        }

        if (conf.state == ReelSymbolStates.SPIN) {
            if(this.multies) this.multies.forEach(m => m.fadeOut(0.3));
            if (this.seq_glows)
                this.seq_glows.forEach(sg => {
                    const startGlow: number = sg.alpha;
                    sg.playAnimation({
                        duration: 0.15,
                        onUpdate: () => {
                            sg!.position = Helper.copyLocalPosition(sg!, this);
                            sg!.alpha = Math.max(startGlow - sg!.timeline!.totalProgress(), 0);
                        }
                    });
                });
            if (this.win_toggle) TweenLite.to(this.win_toggle, 0.2, { alpha: 0 });

            if ((this.isJumpWild || this.isWild) && this.isInactive){
                if(this.jw_mult) this.jw_mult.visible = false;
                return new TimelineMax();
            } 
        }

        if (conf.state === ReelSymbolStates.WIN || conf.state === ReelSymbolStates.IDLE) {
            this.state.set(conf.state);
            return this.playWin(conf)
        }

        if (conf.state === ReelSymbolStates.LANDING) {
            this.state.set(ReelSymbolStates.LANDING);
            return this.playLanding(conf)
        }

        if (conf.state === SanSymState.SPIN_ATTENTION) {
            this.state.set(SanSymState.SPIN_ATTENTION);
            return this.spinAttention(conf)
        }

        if (conf.state === ReelSymbolStates.ATTENTION) {
            this.state.set(ReelSymbolStates.ATTENTION);
            return this.playAttention(conf)
        }

        if (this.state.equal(ReelSymbolStates.INACTIVE) && conf.state != ReelSymbolStates.SPIN) return new TimelineMax();

        if (conf.state === ReelSymbolStates.CHANGE_SYMBOL && this.isScatter) {
            this.state.set(ReelSymbolStates.CHANGE_SYMBOL);
            return this.changeToWild(conf)
        }

        if (conf.state === ReelSymbolStates.CHANGE_SYMBOL && "Z") {
            this._timeLine = Helper.timeLineKiller(this._timeLine!, new TimelineMax(), true);
            this.textureAnimation(conf)!;
            return this._timeLine!;
        }
       
        return super.changeState(conf);
    }

    hintValue(val:number,ways:number) {
        ReelOverlay.instance.playValueText(this,val,ways);
    }

    public isFSMarked(amm:number): void {
        
        if(amm == 0){
            if(this.fsMultBars)this.fsMultBars.forEach(f => f.visible = false);
            if(this.multies) this.multies!.forEach(f => f.visible = false);
            return;
        }

        if(!this.fsMultBars){
            var baseTexture:PIXI.Texture = GameResources.getTextures("Sym_Frame_Multiplier" + (this.stateType.equal(4) ? "" : "_2"))[0];
            this.fsMultBars = ArrayHelper.initArrayWithValues(4,() => new PIXI.Sprite(baseTexture));
            this.fsMultBars.forEach((f,i) => { 
                f.anchor.set(0.5,0.5);
                f.alpha = !i ? 1 : 0;
            });
            this._attentionGFX.zIndex = 550;
            this.addChild(...this.fsMultBars);
        }

        if (!this.multies && !this.jw_mult) {
            this.multies = ArrayHelper.initArrayWithValues(4,() => new SymbolMultiplyCounter);
            this.multies.forEach((f,i) => { 
                f.anchor.set(0.5,0.5);
                f.alpha = !i ? 1 : 0;
            });
            this.multies[0].position.y = this.stateType.equal(4) ? Math.floor(130 / 2) : Math.floor(42 / 2);
            
            this.addChild(...this.multies);
        }

        this.fsMultBars.forEach(f=> { f.zIndex = 100;});
        if(this.multies) this.multies.forEach(f=> { 
            f.zIndex = 200;
            f.apply(amm)
        });

        this.sortChildren();
    }

    private spinAttention(config: ISymbolAnimationConf): TimelineMax {
        this.changeState({ state: ReelSymbolStates.NORMAL, duration: 0 });
        this.attentionFlash(1);

        if (!this.attention_Spin) {
            this.attention_Spin = this.addChild(Sequence.createSequence(GameResources.getTextures(this.attentionSp_Spin_path)));
            this.attention_Spin.blendMode = BLEND_MODES.ADD;
            this.attention_Spin.alpha = 1;
            this.attention_Spin.scale.y = 2;
            this.attention_Spin.anchor.y = 0.75;
        }
        return this.attention_Spin.playAnimation();
    }

    protected textureAnimation(config: ISymbolAnimationConf): void {

        if (config.newSym == "X" || this.symName == "X" && config.state == ReelSymbolStates.NORMAL) {
            const numRand: number = MathHelper.randomIntInRange(0, 4);
            config.state = ReelSymbolStates.NORMAL + (numRand > 0 ? numRand : 0).toString();
        }
        if (this.symName == "Z" && config.state == ReelSymbolStates.CHANGE_SYMBOL) {
            config.state = config.newSym == "W" ? "police" : "normal";
        }

        if (this.isJumpWild && config.state == ReelSymbolStates.CHANGE_SYMBOL) {
            config.state = this.jw_mult ?  "empty" : "normal";
            
        }

        super.textureAnimation(config);
    }

    public setInteractive(val: boolean): void {
        if (this.currentStateAnim) {
            this.currentStateAnim!.interactive = val;
            if (val)
                this.currentStateAnim!.on('pointerdown', () => this.sendToMiniTable());
            else
                this.currentStateAnim!.off('pointerdown', () => this.sendToMiniTable());
        }
    }

    public applyMysteryExplosion():void{
        if (!this.seq_transform) {
            this.seq_transform = this.addChild(Sequence.createSequence(GameResources.getTextures("Mystery_Explode")));
            this.seq_transform.scale.set(2,2);
            this.seq_transform.anchor.set(0.5, 0.5);
            this.seq_transform.alpha = 1;
            this.seq_transform.zIndex = 500;
            this.sortChildren();
        }
    }

    public mysteryExplosion():TimelineMax{
        if(!this.seq_transform) this.applyMysteryExplosion();
        
        if(!this.fsMultBars){
            var baseTexture:PIXI.Texture = GameResources.getTextures("Sym_Frame_Multiplier" + (this.stateType.equal(4) ? "" : "_2"))[0];
            this.fsMultBars = ArrayHelper.initArrayWithValues(1,() => new PIXI.Sprite(baseTexture));
            this.fsMultBars.forEach((f,i) => { 
                f.anchor.set(0.5,0.5);
                f.alpha = !i ? 1 : 0;
            });
            this.addChild(...this.fsMultBars);
            this.fsMultBars.forEach(f => { 
                f.zIndex = 400;
            });
        }

        if (!this.multies) {
            this.multies = ArrayHelper.initArrayWithValues(1,() => new SymbolMultiplyCounter);
            this.multies.forEach((f,i) => { 
                f.anchor.set(0.5,0.5);
                f.alpha = !i ? 1 : 0;
            });
            this.multies[0].position.y = this.stateType.equal(4) ? Math.floor(130 / 2) : Math.floor(42 / 2);
            this.multies.forEach(f=> { 
                f.zIndex = 300;
            });
            this.addChild(...this.multies);
        }
        this.sortChildren();

        return this.seq_transform!.playAnimation({onCompleteCallback:() => this.seq_transform!.visible = false});
    }

    public showAppliedValue(val:number):TimelineMax{
        return this.multies![0].addValue(val,0.25)
    }

    public playWin(config: ISymbolAnimationConf): TimelineMax {

        this._timeLine = Helper.timeLineKiller(this._timeLine!,new TimelineMax(),true);

        if(this.isJumpWild && this.jw_mult) {
            this.state.set("empty"); 
        }

        const TEXTURES: Texture[] | undefined = SymbolData.getTextureFromConfig(this._symConfig, this.state.state, this.stateType.state);
        const TEXTURES2: Texture[] | undefined = SymbolData.getTextureFromConfig(this._symConfig, this.state.equal("empty") ? this.state.state :config.state, this.stateType.state);

        this._currentAnimation!.setTexture(TEXTURES!);
        this._oldAnimation!.setTexture(TEXTURES2!);

        this._currentAnimation!.stop();
        this._oldAnimation!.stop();

        let durr: number = Math.max(this._currentAnimation.totalDuration, this._oldAnimation.totalDuration);

        durr = config.duration == undefined ? durr : config.duration;
        this.createWinFlash();
        const isIdle: boolean = config.state == ReelSymbolStates.IDLE;
        if (isIdle) this.createSetFrame(config);

        if (!this.isLowValue && this.isNormalSym && isIdle && this.stateType.equal(4)) {
            this.createSpine();
            this.win_toggle.play({ duration: durr, name: this.symName + "_Win", loop: false });
        }

        this.onResize();

        this._timeLine!.add([
            () => {
                if (this.win_toggle) this.win_toggle.alpha = 1;
                this._currentAnimation.alpha = 0;
                if (isIdle) {
                    this.winFrameSeq.forEach(sf => {
                        sf.visible = true;
                        sf.alpha = 1;
                    })
                }

                this._oldAnimation.alpha = 1;
                this.winFlashSprites.forEach(sg => {
                    let scaleSizetype: number = this.stateType.equal(4) ? 2 : this.stateType.equal(2) ? 1 : 0.5;
                    sg.scale = MathHelper.pointMul(SanEngineManager.dim.scale, new PIXI.Point(1, scaleSizetype))
                }
                );
            },
            this._oldAnimation.playAnimation({ duration: durr }),
            this.attentionDarkness(0, 25),
        ])
        if (isIdle) {
            this.winFrameSeq.forEach(sf => this._timeLine!.add(sf.playAnimation({ duration: durr }), 0))
        }

        this.winFlashSprites.forEach(sg => {
            sg.setLvl(config.type);
            this._timeLine!.to(sg, durr / 2, { alpha: 1 }, 0);
            this._timeLine!.to(sg, durr / 2, { delay: durr / 2, alpha: 0 }, 0);
        });

        if (isIdle) this.winFrameSeq?.forEach(sf =>  this._timeLine!.to(sf, durr * 0.2, { delay: durr * 0.8, alpha: 0 }, 0)); 

        this._timeLine!.add(() => {
            if (this.win_toggle) this.win_toggle.alpha = 0;
            if (isIdle) {
                this.winFrameSeq?.forEach(sf => sf.visible = false);
            }

            this._currentAnimation.alpha = 1;
            this._oldAnimation.alpha = 0;
            this.changeState({ state: this.state.equal("empty") ? this.state.state : ReelSymbolStates.NORMAL });
        })

        return this._timeLine!;
    }

    public glowBiggy(duration: number, lvl: number): TimelineMax {
        this.createWinFlash();
        this.seq_glows![0].stop();
        return this.seq_glows![0].play({
            duration: duration,
            onUpdate: () => {
                this.winFlashSprites.forEach(sg => {
                    sg.alpha = 1 - this.seq_glows![0]!.timeline!.progress() * 0.6;
                });
            },
            onCompleteCallback: () => this.glowLoop(duration)
        }, lvl);
    }

    private glowLoop(duration: number): TimelineMax {
        return this.seq_glows![0].playAnimation({
            duration: duration,
            onUpdate: () => {
                const nt: number = this.seq_glows![0].timeline!.progress();
                this.winFlashSprites.forEach(sg => {
                    if (nt < .5) {
                        sg.alpha = 0.4 + (nt * 0.6) * 2;

                    } else {
                        sg.alpha = 1 - ((nt - 0.5) * 2) * 0.6;
                    }
                });
            },
            onCompleteCallback: () => this.glowLoop(duration)
        })
    }

    public glow(duration: number, lvl: number): TimelineMax {
        this.createWinFlash();
        this.seq_glows![0].stop();
        this.onResize();
        return this.seq_glows![0].play({
            duration: duration,
            onUpdate: () => {
                const alpha: number = 1 - this.seq_glows![0].timeline!.totalProgress();
                this.winFlashSprites.forEach(sg => { sg.alpha = alpha; });
            },
            onCompleteCallback: () => {
                this.winFlashSprites.forEach(sg => { sg.alpha = 0; });
            }
        }, lvl);
    }

    public glowFirstFs(duration: number, lvl: number): TimelineMax {
        this.createWinFlash();
        this.seq_glows?.forEach(c => c.zIndex = 800);
        this.sortChildren();

        this.onResize();

        return this.seq_glows![0].play({
            duration: duration,
            onUpdate: () => {
                const alpha: number = 1 - this.seq_glows![0].timeline!.totalProgress();
                this.winFlashSprites.forEach(sg => { sg.alpha = alpha; });
            },
            onCompleteCallback: () => {
                this.winFlashSprites.forEach(sg => { sg.alpha = 0; });
            }
        }, lvl);
    }

   


    private playLanding(config: ISymbolAnimationConf): TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine!, new TimelineMax());

        const toConf: ISymbolConfig = config.newSym ? SymbolData.getSymbolConfig(config.newSym!) : this._symConfig;

        const TEXTURES: Texture[] | undefined = SymbolData.getTextureFromConfig(this._symConfig, this.state.state, this.stateType.state);
        const TEXTURES2: Texture[] | undefined = SymbolData.getTextureFromConfig(toConf, config.state, this.stateType.state);

        this._currentAnimation!.setTexture(TEXTURES!);
        this._oldAnimation!.setTexture(TEXTURES2!);

        this._currentAnimation!.stop();
        this._oldAnimation!.stop();

        this._currentAnimation.alpha = 0;
        this._oldAnimation.alpha = 1;

        if (this.attention_Spin) {
            this.attention_Spin.setTexture(GameResources.getTextures("FlyBy_Land"));
            this.attention_Spin.playAnimation({ onCompleteCallback: () => this.attention_Spin!.alpha = 0 });
        }

        let durr: number = Math.max(this._currentAnimation.totalDuration, this._oldAnimation.totalDuration);
        // this._oldAnimation.playAnimation({duration:durr});
        return this._oldAnimation.playAnimation({
            duration: durr, onCompleteCallback: () => {
                this.changeState({ state: ReelSymbolStates.NORMAL, newSym: config.newSym! })
            }
        });
    }

    protected playAttention(config: ISymbolAnimationConf): TimelineMax {
        if (!this.seq_attention) {
            this.seq_attention = this.addChild(Sequence.createSequence(GameResources.getTextures(this.seq_attention_path)));
            const animDurr: number = this.seq_attention.totalDuration;

            this.tl_Loop = new TimelineMax({
                repeat: -1, repeatDelay: 0,
                onStart: () => {
                    this.seq_attention?.playAnimation({ onUpdate: () => this.seq_attention!.alpha = this.seq_attention!.timeline!.progress() })
                },
                onRepeat: () => {
                    this.seq_attention!.alpha = 1;
                    this.seq_attention?.playAnimation({
                        reverse: !this.seq_attention_reverse
                    })
                    this.seq_attention_reverse = !this.seq_attention_reverse;
                }
            });
            this.tl_Loop.to(this, animDurr, {});
        }
        return this.seq_attention?.playAnimation();
    }

    private changeToWild(config: ISymbolAnimationConf): TimelineMax {
        if (!this.seq_transform) {
            this.seq_transform = this.addChild(Sequence.createSequence(config.animated ? GameResources.getTextures("S_W_A_E") : GameResources.getTextures(this.seq_attention ? "S_W_A_T" : "S_W_T")));

            this.seq_transform_end = this.addChild(Sequence.createSequence(config.animated ? [] : GameResources.getTextures("S_W_E")));
            this.seq_transform_end.anchor.set(0.5, 0.5);
            this.seq_transform.anchor.set(0.5, 0.5);

            if (this.seq_attention) this.seq_attention.zIndex = 2.9;
            this.seq_transform.zIndex = 3;
            this.seq_transform_end.zIndex = 3.5;
            this.sortChildren();
        }
        config.duration = this.seq_transform.totalDuration;
        this._timeLine = this.playTransformAnimation(config);
        this.seq_transform!.alpha = 1;
        this._timeLine.add(() => this.seq_transform!.playAnimation({
            onCompleteCallback: () => this.seq_transform!.alpha = 0,
        }), 0)

        this._timeLine.add([
            () => {
                Helper.timeLineKiller(this.tl_Loop);
                if (this.seq_attention) {
                    this.seq_attention.stop();
                    this.seq_attention.alpha = 0;
                }
            },
            () => this.seq_transform_end!.playAnimation({
                onStart: () => this.seq_transform_end!.alpha = 1,
                onCompleteCallback: () => this.seq_transform_end!.alpha = 0,
            })
        ], this.seq_transform.totalDuration);

        this._timeLine.to(this, this.seq_transform_end!.totalDuration, {}, this.seq_transform.totalDuration);

        return this._timeLine;
    }

    public setJWValue(amm:number,duration:number): void {
        this._timeLine! = Helper.timeLineKiller(this._timeLine!,new TimelineMax(),true);

        const toConf:ISymbolConfig = SymbolData.getSymbolConfig("W_J");
        const toType:any = 4;
        
        const TEXTURES:Texture[] | undefined = SymbolData.getTextureFromConfig(this._symConfig, this.state.state, this.stateType.state);
        let TEXTURES2:Texture[] | undefined = SymbolData.getTextureFromConfig(toConf, amm >= 2 ? "empty" : "normal", toType);

        this.type = 4;
        this._symConfig = toConf;
        this.symName
        this.state.set(amm >= 2 ? "empty" : "normal");

        this._attentionGFX.visible = false;

        if (this.multies) this.multies.forEach(r => r.visible = false);

        if(amm >= 2){
            if(!this.jw_mult){
                this.jw_mult = this.addChild(new PIXI.Sprite());
                this.jw_mult.anchor.set(0.5,0.5);
                this.jw_mult.zIndex = 450;
                this.sortChildren();
            }
            this.jw_mult.texture = GameResources.getTextures("JW_Multiplier/X_"+ amm)[0];
        }

        this._currentAnimation!.setTexture(TEXTURES2!);
        this._oldAnimation!.setTexture(TEXTURES!);

        if(duration == 0){
            this._currentAnimation.alpha = 1;
            this._oldAnimation.alpha = 0;
            if(this.jw_mult) this.jw_mult.alpha = 1;
        }else{
            this._timeLine!.fromTo(this._currentAnimation, duration,{alpha:0}, {alpha:1},0)
            if(this.jw_mult) this._timeLine!.fromTo(this.jw_mult, duration,{alpha:0}, {alpha:1},0)
            this._timeLine!.fromTo(this._oldAnimation , duration,{alpha:1}, {alpha:0},0);
        }
    }

    public defineSplit(amount: number): TimelineMax {
        if (this.symName == ReelSymbolName.BONUS || this.isJumpWild) return new TimelineMax();

        return this.Split(amount);
    }

    public defineMult(amount: number, duration: number = 0.5): TimelineMax {
        if (this.symName == ReelSymbolName.BONUS) return new TimelineMax();

        const rr: number = JumpingWildController.instance.itemExists((<SanEngineController>this.parent.parent).reelID, this.posID);
        if (rr >= 0 && JumpingWildController.instance.getExistingItem(rr)) {
            amount += JumpingWildController.instance.getExistingItem(rr)!.multValue;
        }

        if (!this.multies && !this.jw_mult) {
            this.multies = ArrayHelper.initArrayWithValues(4,() => new SymbolMultiplyCounter);
            this.multies.forEach((f,i) => { 
                f.anchor.set(0.5,0.5);
                f.alpha = !i ? 1 : 0;
            });
            this.multies[0].position.y = (this.stateType.equal(4) ? 180 / 2 : 180 / 3) - this.multies[0].height / 2;
            this.addChild(...this.multies);
        }
       
        if (!this.multies) return new TimelineMax();
        return this.multies[0].addValue(amount, duration);
    }

    public hideMult(): void {
        if (this.multies) this.multies[0].visible = false;
    }

    public showMult(): void {
        if (this.multies) this.multies[0].visible = true;
    }

    public attentionLoopFlash(active: boolean, durr: number = 0.6): TimelineMax {
        this.createFlash();
        this.attentionSp?.playAnimation({ repeat: active ? -1 : 0 })
        if (active) {
            this.attentionSp?.timeline?.to(this.attentionSp!, durr / 2, { alpha: 0.7 });
            this.attentionSp?.timeline?.to(this.attentionSp!, durr / 2, { alpha: 0 });
        } else if (this.attentionSp) {
            this.attentionSp?.timeline?.to(this.attentionSp!, durr, { alpha: 0 });
        }
        return this.attentionSp?.timeline!;
    }

    public attentionFlash(durr: number = 0.3, tint: number = 0xFFFFFF): TimelineMax {
        this.createFlash();
        this.attentionSp!.tint = tint;
        this.attentionSp?.playAnimation({}).fromTo(this.attentionSp!, durr, { alpha: 1 }, { alpha: 0 }, 0);
        return this.attentionSp?.timeline!;
    }

    public dirrAtt(active: boolean, dirrTop: boolean = false, repeat: number = -1): void {
        if (active) {
            this.createDirrAtt();
            this.directionSeq!.scale.y = dirrTop ? 1 : -1;
            const durr: number = this.directionSeq!.playAnimation({ repeat: repeat }).duration() * 0.8;
            TweenLite.fromTo(this.directionSeq!, durr / 2, { alpha: 0 }, { alpha: 1 });
            TweenLite.to(this.directionSeq!, durr, { alpha: 0, delay: durr * (repeat <= 0 ? 1 : repeat) - durr / 2 });
        } else if (this.directionSeq) {
            TweenLite.to(this.directionSeq!, 0.4, { alpha: 0 }).eventCallback("onComplete", () => this.directionSeq?.stop());
        }
    }

    public createDirrAtt(): void {
        if (!this.directionSeq) {
            this.directionSeq = this.addChild(Sequence.createSequence(GameResources.getTextures(this.direction_path)));
            this.directionSeq.scale.set(1, 1);
            this.directionSeq.blendMode = BLEND_MODES.ADD;
        }
    }

    public createFlash(): void {
        if (!this.attentionSp) {
            this.attentionSp = this.addChild(Sequence.createSequence(GameResources.getTextures(this.attentionSp_path)));
            this.attentionSp.scale.set(1, 0.33);
            this.attentionSp.blendMode = BLEND_MODES.ADD;
        }
    }

    protected playTransformAnimation(config: ISymbolAnimationConf): TimelineMax {
        const toConf: ISymbolConfig = config.newSym ? SymbolData.getSymbolConfig(config.newSym!) : this._symConfig;

        

        const TEXTURES: Texture[] | undefined = SymbolData.getTextureFromConfig(toConf, this.state.state, this.stateType.state);
        let TEXTURES2: Texture[] | undefined = SymbolData.getTextureFromConfig(toConf, this.state.equal(ReelSymbolStates.INACTIVE) ? ReelSymbolStates.INACTIVE : config.state, this.stateType.state);

        this._timeLine = Helper.timeLineKiller(this._timeLine!, new TimelineMax({
            onComplete: () => {
                this.changeSymbol(config.newSym!);
                this.changeState({ state: ReelSymbolStates.NORMAL })
                this.attentionDarkness(0, 25);
            },
            onStart: () => this._oldAnimation.alpha = 1,
            repeat: config.repeat,
            repeatDelay: 0,
        }));

        if (TEXTURES2 == undefined) TEXTURES2 = TEXTURES;
        this._oldAnimation!.setTexture(TEXTURES2!);
        const duration: number = config.duration == undefined ? this._oldAnimation!.totalDuration : config.duration;
        this._timeLine!.add(this._oldAnimation!.playAnimation({ duration: duration }));

        return this._timeLine;
    }

    private createSetFrame(config: ISymbolAnimationConf): void {
        const texturePath: string = (config.state === ReelSymbolStates.WIN ? "Frame_Win_" : "Frame_Toggle_") + this.stateType.state;

        if (!this.seq_frames) {
            const cont: PIXI.Container = StageManager.getLayer(SanGameConfig.instance.LAYERS.WIN_FRAMES.name);
            this.seq_frames = ArrayHelper.initArrayWithValues(4,() => cont.addChild(create()));
            this.seq_frames![0].position = Helper.copyLocalPosition(this.seq_frames![0], this);
        }
        
        if(this.split_syms)this.seq_frames!.forEach((f,i) => f.position = Helper.copyLocalPosition(f, this.split_syms[i]));
        this.seq_frames.forEach(sf => { sf.setTexture(GameResources.getTextures(texturePath)) });
        
        function create(): Sequence {
            const temp: Sequence = Sequence.createSequence();
            temp.anchor.set(0.5, 0.5);
            temp.visible = false;
            temp.scale = SanEngineManager.dim.scale;
            temp.zIndex = 2;
            return temp;
        }
    }

    private createSpine() {
        if (!this.win_toggle) {
            this.win_toggle = this.addChild(new SpinePlayer("Sym_Win"));
            this.win_toggle.alpha = 0;
            this.sortChildren();
        }
    }

    private createWinFlash(): void {

        if (!this.seq_glows) {
            const cont: PIXI.Container = StageManager.getLayer(SanGameConfig.instance.LAYERS.WIN_FRAMES.name);
            this.seq_glows = ArrayHelper.initArrayWithValues(4, () => cont.addChild(create()));
            this.seq_glows![0].position = Helper.copyLocalPosition(this.seq_glows![0], this);
        }
        if (this.Splitted) {
            this.seq_glows!.forEach((f,i) => f.position = Helper.copyLocalPosition(f, this.split_syms[i]))
        }

        function create(): MultSequence {
            const temp: MultSequence = new MultSequence([
                "Blink_Bar_Tiny",
                "Blink_Bar_Small",
                "Blink_Bar_Medium",
                "Blink_Bar_High",
            ]);
            temp.anchor.set(0.5, 0.5);
            temp.alpha = 0;
            temp.blendMode = BLEND_MODES.ADD;
            temp.scale = SanEngineManager.dim.scale;
            temp.zIndex = 1;
            return temp;
        }
    }

    private gfxHeight(): number {
        if (this.stateType.equal(4) || this.Splitted) return 180
        if (this.stateType.equal(2)) return 90;
        return 360; // 7
    }

    public attentionDarkness(alphaValue: number = 0.6, duration: number = 0.2): TimelineMax {
        this._subTimeline = Helper.timeLineKiller(this._subTimeline!, new TimelineMax());
        if (!this.isNormalSym && this.symName != "X") return this._subTimeline;

        const startAlpha = this._attentionGFX.alpha;
        const toAlpha = alphaValue;

        let toSize: number = this.gfxHeight();

        if (this._attentionGFX.height != toSize) {
            this._attentionGFX.clear();
            this._attentionGFX.beginFill(0x000000, 1);
            this._attentionGFX.drawRect(-this.symbolWidht * 0.5, -toSize * 0.5, this.symbolWidht, toSize);
            this._attentionGFX.height = toSize;
            this._attentionGFX.endFill();
        }
        this._subTimeline.fromTo(this._attentionGFX, duration, { alpha: startAlpha }, { alpha: toAlpha });
        return this._subTimeline;
    }

    public changeSizeBg(duration: number = 0.25, size: number = 4): TimelineMax {
        this.sizeTl = Helper.timeLineKiller(this.sizeTl, new TimelineMax());
        let toSize: number = 0;
        if (size == 4 || this.Splitted) toSize = 180;
        if (size == 2) toSize = 90;
        if (size == 1) toSize = 45;
        if (size == 7) toSize = 360;

        this.sizeTl.to(this._attentionGFX, duration, { height: toSize, ease: Bounce.easeOut }, 0);

        if (this.multies) {
            const multP: number = (toSize / 2) - this.multies[0].height / 2;
            this.sizeTl.to(this.multies[0].position, duration, { y: multP, ease: Bounce.easeOut }, 0);
        }

        if (this.fsMultBars) {
            this.fsMultBars.forEach(f => {
                f.texture = GameResources.getTextures("Sym_Frame_Multiplier"+(size == 4 ? "" : "_"+size))[0];
            });
        }

        if (this.attentionSp) {
            const attNewSizeY: number = this.stateType.equal(size) ? 0.33 : 0.18;
            this.sizeTl.to(this.attentionSp.scale, duration, { y: attNewSizeY, ease: Bounce.easeOut }, 0);
        }
        this.sizeTl.play();
        return this.sizeTl;
    }

    public remove(): void {
        if (this.seq_frames) {
            this.seq_frames.forEach(sf => {
                sf.stop();
                StageManager.getLayer(SanGameConfig.instance.LAYERS.WIN_FRAMES.name).removeChild(sf);
                sf.destroy({ children: true })
            });
        }
        if (this.seq_glows) {
            this.seq_glows.forEach(sg => {
                sg.stop();
                StageManager.getLayer(SanGameConfig.instance.LAYERS.WIN_FRAMES.name).removeChild(sg);
                sg.destroy({ children: true })
            });
        };

        this.children.forEach(child => { child.destroy(); });
        this.destroy({ children: true });
        this.removeChildren();
    }

    public onResize(): void {
        const scaleGlow: PIXI.Point = MathHelper.pointMul(SanEngineManager.dim.scale, new PIXI.Point(1, this.stateType.equal(4) ? 2 : 1));
        const scale: PIXI.Point = SanEngineManager.dim.scale;

        if (this.Splitted) {
 
            if (this.seq_frames) {
                this.seq_frames!.forEach((f,i) => {
                    f.position = Helper.copyLocalPosition(f, this.split_syms[i]);
                    f.scale = scale;
                })
            }

            if (this.seq_glows) {
                this.seq_glows!.forEach((f,i) => {
                    f.position = Helper.copyLocalPosition(f, this.split_syms[i])
                    f.scale = scaleGlow;
                })
            }
            

        } else {
            if (this.seq_frames) {
                this.seq_frames[0].position = Helper.copyLocalPosition(this.seq_frames[0], this);
                this.seq_frames[0].scale = SanEngineManager.dim.scale;
            }
            if (this.seq_glows) {
                this.seq_glows[0].position = Helper.copyLocalPosition(this.seq_glows[0], this);
                this.seq_glows[0].scale = scaleGlow;
            }
        }
    }
}
